import React from 'react';
import {
	Analysis,
	CardWrapper,
	ContentWrapper,
	Heading,
	IconWrapper,
	RiskWrapper,
	SubWrapper,
	Wrapper,
	ExploreButton,
} from './Cards.styles';
import { ApIcon, ApLoaderDefault } from '@alixpartners/ui-components';
import { InsightsType } from 'CategoryManagement/utils';
import { cardColorDefault, iconColor } from './utils';
import { useFragmentedCategoriesContext } from 'contexts/CategoryInsightsKpi/FragmentedCategoriesProvider';
import { useState } from 'react';
import ExploreModal from 'CategoryManagement/Explore/ExploreModal';
import FragmentedCategoriesExplore from 'CategoryManagement/Explore/DetailedAnalysis/FragmentedCategoriesExplore';

const FragmentedCategories = ({ name }) => {
	const { isLoading, analysis, gridData } = useFragmentedCategoriesContext();
	const [isExplore, setIsExplore] = useState(false);

	return (
		<>
			<Wrapper>
				<SubWrapper>
					<RiskWrapper tileColor={cardColorDefault} />
					<CardWrapper>
						<IconWrapper iconColor={iconColor}>
							<div>
								<ApIcon
									material={true}
									iconName={InsightsType[1].iconName}
									iconSize={20}
								/>
							</div>
							<div>
								{!isLoading &&
									gridData.rowData.length > 0 && (
										<ExploreButton
											title="Explore"
											className="explore"
											onClick={() => setIsExplore(true)}
										>
											<ApIcon
												title="Explore"
												material={true}
												iconName="find_in_page"
											/>
										</ExploreButton>
									)}
							</div>
						</IconWrapper>
						<IconWrapper />
						{isLoading ? (
							<ApLoaderDefault />
						) : (
							<ContentWrapper>
								<Heading>{name}</Heading>
								<Analysis>{analysis}</Analysis>
							</ContentWrapper>
						)}
					</CardWrapper>
				</SubWrapper>
			</Wrapper>
			{isExplore && (
				<ExploreModal title={name} onClose={setIsExplore}>
					<FragmentedCategoriesExplore />
				</ExploreModal>
			)}
		</>
	);
};

export default FragmentedCategories;
